<template>
  <div v-if="!loading" class="cell-container">
    <ul :class="containerClassName">
      <li
        v-for="(cell, index) in cellList"
        ref="cellList"
        :key="`${cell.thumbnail}_${index}`"
      >
        <InstantPlayCell
          :cell="cell"
          :thumbnail-info="thumbnailInfo"
          @on-click="selectCell"
        />

        <a href="#" @click.prevent="() => selectCell(cell)">
          <div ref="cellImgList" :class="cellImgClass(cell)">
            <div v-if="isAutoPlayCell(cell)" class="play-button">
              <span class="a11y-hidden">재생하기</span>
            </div>
            <img
              v-lazy="getThumbnailImg(cell)"
              :alt="altTitle(cell)"
              :class="'instantplay_' + index"
            />
            <age-tag v-if="cell.age_tag !== ''" :age-code="cell.age_tag" />
            <ul class="badge-list">
              <li
                v-common-tag-list="{
                  badgeList: brandTagList(cell),
                  type: 'brand',
                }"
                class="right-top-area"
              ></li>
            </ul>
          </div>
        </a>
        <div class="cell-info">
          <div class="title-box">
            <p class="view-title">
              <span>{{ title(cell) }}</span>
            </p>
          </div>
          <div v-if="isAutoPlayCell(cell)" class="icon-wrap">
            <icon-box-zzim-with-event
              :event-list="eventList(cell)"
              is-zzim-title="y"
              :zzim="zzim(cell)"
            ></icon-box-zzim-with-event>
            <a
              v-if="isOriginalId(cell) && !isCommingSoon"
              href="#"
              class="icon-box"
              @click.prevent="moveToOriginal(cell)"
            >
              <IconMainMovie />
              <span class="icon-txt">본편 보기</span>
            </a>
          </div>
          <div class="desc-box">
            <span v-if="isCommingSoon" class="comingsoon-release-date">{{
              comingSoonReleaseDate(cell)
            }}</span>
            <strong v-if="comment(cell) !== ''" class="comment">{{
              comment(cell)
            }}</strong>
            <p
              v-if="synopsis(cell) !== ''"
              class="preview"
              v-html="synopsis(cell)"
            ></p>
            <div class="cast">
              <table>
                <caption>
                  출연표
                </caption>
                <colgroup>
                  <col style="width: 34px" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th>출연:&nbsp;</th>
                    <td>
                      <div>
                        <span>{{ actors(cell) }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <span class="scroll-none"></span>
  </div>
</template>
<script>
  import { resizeThumbnail } from '@/common/image.filter'
  import { topTagList, titleList, commonTagList } from '@/common/directives'
  import { getEventListByType } from '@/common/util/event.util'
  import { get, filter } from 'lodash'
  import AgeTag from '@/components/tags/AgeTag'
  import { COOKIE_KEY_VERIFIED_ADULT } from '@/common/constant'
  import utils from '@/common/util/utils'
  import { EventBus } from '@/components/eventbus/EventBus'
  import { ON_CLICK } from '@/common/event.const'
  import { getTitle } from '@/common/util/common'
  import { parseUrl } from 'query-string'
  import { PATH_NAME_PLAYER } from '@/common/router.const'
  import IconBoxZzimWithEvent from '@/components/play/IconBoxZzimWithEvent'
  import IconMainMovie from '@/assets/svg/common/icon-main-movie.svg'
  import InstantPlayCell from '@/components/section/template/cell/cell-catalog/InstantPlayCell.vue'

  export default {
    name: 'CellListInstantPlay',
    components: {
      AgeTag,
      IconBoxZzimWithEvent,
      IconMainMovie,
      InstantPlayCell,
    },
    directives: {
      topTagList,
      titleList,
      commonTagList,
    },
    props: {
      cellList: {
        type: Array,
      },
      thumbnailInfo: {
        type: Object,
      },
      containerClassName: {
        type: String,
      },
      contentInfo: {
        type: Object,
      },
      bottomTab: {
        type: String,
      },
      loading: {
        type: Boolean,
      },
    },
    data() {
      return {
        verifyAdult: false,
        isCommingSoon:
          get(this.$route, 'query.api', '').indexOf('commingsoon') > -1,
      }
    },
    mounted() {
      this.$refs.cellList[0].classList.add('autoplay-on')
      window.addEventListener('scroll', this.scrollEvent)
    },
    created() {
      this.verifyAdult =
        utils.cookies.getItem(COOKIE_KEY_VERIFIED_ADULT) !== '1'
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scrollEvent)
    },
    methods: {
      getThumbnailImg(cell) {
        return resizeThumbnail(cell.thumbnail, this.thumbnailInfo)
      },
      selectCell(cell) {
        if (get(cell, 'event_list', []).length === 0) return // 이미지 편성일 경우 상세보기 진입 x
        const { onNavigationEvent, onClickEvent } = getEventListByType(
          cell.event_list,
        )
        if (onClickEvent) {
          EventBus.$emit(ON_CLICK, onClickEvent)
        }
        let navigationUrl = get(onNavigationEvent, 'url', '').replace(
          '.html',
          '',
        )
        let { url, query } = parseUrl(navigationUrl)
        let section = url.split('/').pop()
        if (section === 'list') {
          this.$router.push({
            name: 'channelclip',
            params: {
              uiCode: query.uicode,
            },
          })
        } else {
          this.$router.push({
            name: PATH_NAME_PLAYER,
            params: {
              section,
            },
            query: query,
          })
        }
      },
      cellImgClass(cell) {
        const eventListUrl = get(cell, ['event_list', '1', 'url'], '')
        const type = eventListUrl.indexOf('player/movie') > -1 ? 'movie' : 'vod'
        const isDim =
          Number(get(cell, 'age', 0)) >= 21 &&
          (utils.cookies.getCredential() === 'none' || this.verifyAdult)
        if (isDim) {
          return type === 'movie' ? 'cell-img adult' : 'cell-img vod-adult'
        } else {
          return 'cell-img ' + this.$route.name
        }
      },
      altTitle(cell) {
        return getTitle(cell)
      },
      title(cell) {
        return get(cell, 'title_list.0.text', '')
      },
      comment(cell) {
        return get(cell, 'description', '')
      },
      synopsis(cell) {
        return get(cell, 'synopsis', '')
      },
      eventList(cell) {
        return get(cell, 'event_list', [])
      },
      zzim(cell) {
        return get(cell, 'iszzim', 'n').toLowerCase()
      },
      actors(cell) {
        return get(cell, 'actors', '')
      },
      comingSoonReleaseDate(cell) {
        return get(cell, 'commingSoonReleaseDate', '')
      },
      isOriginalId(cell) {
        return get(cell, 'contentid', '') !== ''
      },
      getType(cell) {
        const { onZzimEvent } = getEventListByType(get(cell, 'event_list', []))
        return get(onZzimEvent, 'bodyjson.contenttype', '')
      },
      moveToOriginal(cell) {
        let queryObj = { movieid: get(cell, 'contentid', '') }
        if (this.getType(cell) === 'program') {
          queryObj = { contentid: get(cell, 'contentid', '') }
        }
        this.$router.push({
          name: PATH_NAME_PLAYER,
          params: {
            section: this.getType(cell) === 'program' ? 'vod' : 'movie',
          },
          query: queryObj,
        })
      },
      scrollEvent() {
        let imgElList = this.$refs.cellImgList
        let imgElListLength = imgElList.length
        const filteredElList = filter(imgElList, (imgEl) => {
          const rect = imgEl.getBoundingClientRect()
          if (
            rect.top * -1 + 56 <=
            imgEl.scrollHeight - (imgEl.clientHeight * 30) / 100
          ) {
            return imgEl
          }
        })
        this.$refs.cellList.forEach((li, index) => {
          if (index === imgElListLength - filteredElList.length) {
            li.classList.add('autoplay-on')
          } else if (index !== imgElListLength - filteredElList.length) {
            li.classList.remove('autoplay-on')
          }
        })
      },
      isAutoPlayCell(cell) {
        return get(cell, 'event_list', []).length > 0
      },
      brandTagList(cell) {
        return get(cell, 'brand_taglist', [])
      },
    },
  }
</script>
<style scoped>
  .cell-circle .cell-img.clip img,
  .cell-circle .cell-img.live img {
    width: 100%;
    height: 100%;
    margin: 0 0 0 0;
  }

  img[lazy='loading'] {
    opacity: 0.5;
  }

  img[lazy='error'] {
    opacity: 1;
  }

  img[lazy='loaded'] {
    -webkit-transition: opacity 350ms ease-in-out;
    -moz-transition: opacity 350ms ease-in-out;
    -o-transition: opacity 350ms ease-in-out;
    transition: opacity 350ms ease-in-out;
  }
  .tag-age {
    position: absolute;
    height: 20px;
  }
  .progress-bar {
    display: block;
    height: 3px;
    background-color: #1351f9;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#5654e1', endColorstr='#2ac5fe', gradientType=1);
  }
  .circle {
    height: 84px;
  }
  .circle-progress {
    position: absolute;
    z-index: 100;
    width: 84px;
    height: 84px;
    border-radius: 42px;
    overflow: hidden;
  }
  .circle-img {
    width: 84px;
    height: 84px;
    border-radius: 42px;
    overflow: hidden;
  }
  /* 첫번째 vod 재생 overlay */
  .vod-playnow:after {
    position: absolute;
    display: block;
    content: '';
    top: 50%;
    margin-top: -18px;
    left: 50%;
    margin-left: -18px;
    width: 36px;
    height: 36px;
    background: url(/img/common/ic-now-play.png);
    background-size: 36px 36px;
    z-index: 200;
  }
  .cell-img.adult {
    position: relative;
  }
  .cell-img.adult .tag-age {
    opacity: 0.2;
  }

  /*
.cell-img.adult img{
  z-index: 500 !important;
  opacity: 0.1;
  background-color: #000000;
}*/

  .cell-img .adult-21 {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 46px;
    height: 46px;
  }
</style>
